
import moment from "moment";

export function timeSince(date) {
  date = new Date(date);
  var seconds = Math.floor((new Date() - date) / 1000);

  var interval = seconds / 31536000;

  if (interval > 1) {
    return Math.floor(interval) + " year ago";
  }
  interval = seconds / 2592000;
  if (interval > 1) {
    return Math.floor(interval) + " month ago";
  }
  interval = seconds / 86400;
  if (interval > 1) {
    return Math.floor(interval) + " day ago";
  }
  interval = seconds / 3600;
  if (interval > 1) {
    return Math.floor(interval) + " hour ago";
  }
  interval = seconds / 60;
  if (interval > 1) {
    return Math.floor(interval) + " minute ago";
  }
  return Math.floor(seconds) + " second ago";
}
function adjustBrightness(hex, percent) {
  const num = parseInt(hex.replace("#", ""), 16);
  const amt = Math.round(2.55 * percent);
  const R = (num >> 16) + amt;
  const G = ((num >> 8) & 0x00ff) + amt;
  const B = (num & 0x0000ff) + amt;
  return (
    "#" +
    (
      0x1000000 +
      (R < 255 ? (R < 1 ? 0 : R) : 255) * 0x10000 +
      (G < 255 ? (G < 1 ? 0 : G) : 255) * 0x100 +
      (B < 255 ? (B < 1 ? 0 : B) : 255)
    )
      .toString(16)
      .slice(1)
  );
}

function isLightColor(hex) {
  const rgb = parseInt(hex.replace("#", ""), 16);
  const r = (rgb >> 16) & 0xff;
  const g = (rgb >> 8) & 0xff;
  const b = (rgb >> 0) & 0xff;
  const luma = 0.2126 * r + 0.7152 * g + 0.0722 * b; // per ITU-R BT.709
  return luma > 128;
}

export function adjustTextColor(backgroundColor) {
  if (!backgroundColor || !backgroundColor.startsWith("#")) {
    return "#000000"; // Default to black if invalid input
  }

  const isLight = isLightColor(backgroundColor);
  return isLight
    ? adjustBrightness(backgroundColor, -65)
    : adjustBrightness(backgroundColor, 90);
}

export const calculateTotalOvertimeHours = (records) => {
  let totalMinutes = 0;

  records?.forEach((record) => {
    const punchRecord = record?.punchRecord?.[0] || {};
    const Overtime = punchRecord?.Overtime || null;

    if (Overtime) {
      const timeToMinutes = (time) => {
        if (!time || typeof time !== "string") return 0;
        const [hours, minutes] = time.split(":").map(Number);
        return hours * 60 + minutes;
      };

      totalMinutes += timeToMinutes(Overtime.earlyCommingEntryHoursTime);
      totalMinutes += timeToMinutes(Overtime.lateOutOvertimeHoursTime);
    }
  });

  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  return `${hours.toString().padStart(2, "0")}:${minutes
    .toString()
    .padStart(2, "0")}`;
};

export const calculateTotalFineHours = (records) => {
  let totalMinutes = 0;

  records?.forEach(({ punchRecord }) => {
    const { fine } = punchRecord?.[0];

    if (fine) {
      const timeToMinutes = (time) => {
        if (!time) return 0;
        const [hours, minutes] = time.split(":").map(Number);
        return hours * 60 + minutes;
      };
      totalMinutes += timeToMinutes(fine.lateEntryFineHoursTime);
      totalMinutes += timeToMinutes(fine.earlyOutFineHoursTime);
      totalMinutes += timeToMinutes(fine.excessBreakFineHoursTime);
    }
  });

  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  return `${hours.toString().padStart(2, "0")}:${minutes
    .toString()
    .padStart(2, "0")}`;
};

export const calculateFinePerMinute = (
  monthlySalary,
  workingDays = 30,
  workingHoursPerDay = 8
) => {
  const finePerMinute = monthlySalary / (workingDays * workingHoursPerDay * 60);
  console.log("monthly salary", monthlySalary);
  return finePerMinute >= 0 ? Number(finePerMinute.toFixed(2)) : 0;
};

export const calculateShiftAndPunchDifferences = (shift, punch) => {
  if (!shift || !punch) return "00:00";

  const shiftTime = moment(shift, "hh:mm A");
  const punchTime = moment(punch);

  const diffMinutes = punchTime.diff(shiftTime, "minutes");
  const hours = Math.floor(Math.abs(diffMinutes) / 60);
  const minutes = Math.abs(diffMinutes) % 60;

  return `${hours.toString().padStart(2, "0")}:${minutes
    .toString()
    .padStart(2, "0")}`;
};

export const calculateWorkHours = (punchInTime, punchOutTime) => {
  if (!punchInTime || !punchOutTime) return "00:00";

  const inTime = moment(punchInTime);
  const outTime = moment(punchOutTime);

  const diffMinutes = outTime.diff(inTime, "minutes");
  const hours = Math.floor(diffMinutes / 60);
  const minutes = diffMinutes % 60;

  return `${hours.toString().padStart(2, "0")}:${minutes
    .toString()
    .padStart(2, "0")}`;
};
